import styled from 'styled-components';

const UpdateICConfigWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  .ant-input {
    font-family: regular_medium !important;
  }
  .submit-ic-code {
    margin-top: 10px;
  }
`;

export default UpdateICConfigWrapper;


// WEBPACK FOOTER //
// ./src/components/IC/UpdateICConfig/UpdateICConfig.style.js